import { createSlice } from '@reduxjs/toolkit';

export const documentSlice = createSlice({
  name: 'document',
  initialState: {
    documentType: 0,
    documents: {},
    summary: [],
    uploadedFiles: [],
    requestId: '',
    isFileUpload: false,
    uploadProgress: 1,
    isUploading: false,
  },
  reducers: {
    setDocumentType: (state, action) => {
      state.documentType = action.payload;
    },
    setRequestId: (state, action) => {
      state.requestId = action.payload;
    },
    setDocuments: (state, action) => {
      state.documents = {};
      action.payload.forEach(element => {
        state.documents[element.name] = element;
      });
    },
    setSummary: (state, action) => {
      state.summary = [];
      action.payload.forEach(element => {
        state.summary.push(element);
      });
    },
    reSetDocuments: (state) => {
      state.documents = {};
    },
    updateDocuments: (state, action) => {
      state.documents[action.payload.name] = action.payload;
    },
    addFile: (state, action) => {   
      let { name, size, type, lastModified } = action.payload;
      state.uploadedFiles.push({ name, size, type, lastModified });
    },
    isFileUpload: (state, action) => {
      state.isFileUpload = action.payload
    },
    setUploadProgress: (state, action) => {
      state.uploadProgress = 1;
      state.uploadProgress = action.payload;
    },
    setIsUploading: (state, action) => {
      state.isUploading = false;
      state.isUploading = action.payload;
    },
  },
});
export const { setDocumentType, reSetDocuments, updateDocuments, setSummary, setRequestId, addFile, isFileUpload, setUploadProgress, setIsUploading } = documentSlice.actions;

export default documentSlice.reducer;
